import { trpc } from 'root/src/client/v2/trpc/trpc';
import { useCreatorData } from 'root/src/client/logic/api/hooks/useCreatorData';
import { Platform } from 'root/src/shared/@types/platforms';
export const useCreatorLiveStream = () => {
    var _a, _b;
    const creatorData = useCreatorData();
    const platform = creatorData === null || creatorData === void 0 ? void 0 : creatorData.platform;
    const platformId = creatorData === null || creatorData === void 0 ? void 0 : creatorData.platformId;
    const isTwitchCreator = platform === Platform.Twitch;
    const { data } = trpc.creators.getCreatorLiveStream.useQuery({ platform: platform, platformId: platformId }, {
        enabled: isTwitchCreator && !!platformId,
        refetchInterval: 60000,
    });
    return {
        isLive: (_a = data === null || data === void 0 ? void 0 : data.isLive) !== null && _a !== void 0 ? _a : false,
        stream: (_b = data === null || data === void 0 ? void 0 : data.stream) !== null && _b !== void 0 ? _b : null,
        channelName: creatorData === null || creatorData === void 0 ? void 0 : creatorData.mnemonicId,
        isTwitchCreator,
    };
};
